export const sortData = (data, sortConfig) => {
    if (!sortConfig.key) return data; // No sorting applied
  
    return [...data].sort((a, b) => {
      let valueA = a[sortConfig.key] || "";
      let valueB = b[sortConfig.key] || "";
  
      if (typeof valueA === "string") valueA = valueA.toLowerCase();
      if (typeof valueB === "string") valueB = valueB.toLowerCase();
  
      if (valueA < valueB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valueA > valueB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  };